import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable } from '@y42/angular/util';
import { ErrorHandlerService } from '@y42/error-handling';
import { Observable, switchMap } from 'rxjs';
import { AbstractFeatureUIModel } from '../../../models';
import { AssetSidebarService } from '../asset-sidebar.service';

@UntilDestroy()
@Component({
  selector: 'y42-open-in-asset-sidebar-button',
  templateUrl: './open-in-asset-sidebar-button.component.html',
  styleUrls: ['./open-in-asset-sidebar-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OpenInAssetSidebarButtonComponent {
  constructor(
    private readonly assetSidebarService: AssetSidebarService,
    private readonly errorHandlerService: ErrorHandlerService,
  ) {}

  @Input()
  @InputObservable()
  path?: AbstractFeatureUIModel['$path'];
  path$!: Observable<AbstractFeatureUIModel['$path'] | undefined>;
  @Input()
  tooltipPosition: TooltipPosition = 'right';

  public readonly state = connectState(this, {
    isActive: this.path$.pipe(switchMap(($path) => this.assetSidebarService.selectIsActive($path))),
  });

  openInAssetSidebar(evt: MouseEvent) {
    if (!this.path) {
      this.errorHandlerService.handleError(`[OpenInAssetSidebarButton]: missing path`);
      return;
    }

    evt.stopPropagation();

    if (this.state.isActive) {
      this.assetSidebarService.close();
    } else {
      this.assetSidebarService.setActive(this.path);
    }
    return false;
  }
}
